import { capitaliseSentence } from "./services/capitaliseSentence";
import { Controller, useFormContext } from "react-hook-form";

import { cn, ui } from "@patient-watch/ui";

interface Props {
    label: string;
    name: string;
    options: string[];
}

const MultipleChoiceCards = ({ label, name, options }: Props) => {
    const { control } = useFormContext();

    return (
        <ui.Card>
            <ui.CardHeader>
                <ui.Label>{label}</ui.Label>
            </ui.CardHeader>
            <ui.CardContent>
                <Controller
                    name={name}
                    control={control}
                    render={({ field: { value, onChange } }) => (
                        <ul className="flex flex-col gap-y-2">
                            {options?.map((o) => {
                                const optionId = `${name}-${o}`;
                                const checked = Array.isArray(value) && value.includes(o);
                                return (
                                    <li key={o}>
                                        <label
                                            htmlFor={optionId}
                                            className={cn(
                                                "flex items-center gap-2 py-1 pl-2 rounded-md transition-[box-shadow] duration-200 cursor-pointer",
                                                checked && "ring-2 ring-indigo-600 dark:ring-indigo-400"
                                            )}
                                        >
                                            <ui.Checkbox
                                                id={optionId}
                                                checked={checked}
                                                onCheckedChange={(isChecked: boolean | "indeterminate") => {
                                                    const newValue = Array.isArray(value) ? [...value] : [];
                                                    if (isChecked === true) {
                                                        if (!newValue.includes(o)) {
                                                            newValue.push(o);
                                                        }
                                                    } else if (isChecked === false) {
                                                        newValue.splice(newValue.indexOf(o), 1);
                                                    }
                                                    onChange(newValue);
                                                }}
                                            />
                                            <span className="py-2.5 w-full font-normal text-sm capitalize leading-snug">
                                                {capitaliseSentence(o, "-")}
                                            </span>
                                        </label>
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                />
                <ui.FormMessage />
            </ui.CardContent>
        </ui.Card>
    );
};

export default MultipleChoiceCards;
